/** Compares two strings so entries starting with letters sort before numbers. */
export function lettersBeforeNumbers(a, b) {
  var aIsNumber = /^\d/.test(a);
  var bIsNumber = /^\d/.test(b);
  if (aIsNumber !== bIsNumber) return aIsNumber ? 1 : -1;
  return a.localeCompare(b);
}